module.exports = __webpack_public_path__ + "img/cb9f1a1.png";